import React from 'react';
import "./styles.css";
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom'
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Home from './Home';
import LoginContainer from './components/Login/LoginContainer';
import Privacy from './components/Privacy/Privacy';
import Terms from './components/Privacy/Terms';
import AccountRemoval from './components/Privacy/AccountRemoval';
import OrderList from './components/OrderList/OrderList';
import PhotographerList from './components/PhotographerList/PhotographerList';
import CustomerList from './components/CustomerList/CustomerList';
import DiscountList from './components/DiscountList/DiscountList';
import FeedbackPage from './components/Feedback/FeedbackPage';
import PaymentList from './components/Payments/PaymentList';
import CustomerRatingsPage from './components/CustomerRatings/CustomerRatingsPage';
import PendingRequestsPage from './components/PendingRequests/PendingRequestsPage';
import ReviewsPage from './components/Reviews/ReviewsPage';
import AdminsPage from './components/Admins/AdminsPage';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import ContentPage from './components/ContentPage';
import PushNotifications from './components/PushNotifications';
import AddUnavailableDates from './components/AddUnavailableDates';
import LiveTrackingMap from './components/LiveTrackingMap';
import AvailabilityPage from './components/Availability/AvailabilityPage';
import AnalyticsPage from './components/Analytics/AnalyticsPage';

const App = ({ navigate, location }: any) => {
  //WE ARE NOT MAKING USE OF HISTORY BECAUSE THE ANIMATIONS WORK IF THE PAGE IS BEING MOUNTED THROUGH NATIVE REDIRECTION
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      {document.documentElement.clientWidth < 1100 && (window.location.pathname !== '/' && window.location.pathname !== '/accountremoval' && window.location.pathname !== '/terms' && window.location.pathname !== '/privacy-policy') ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: "lightgray" }}>
        <h1>Unsupported Device</h1>
      </div> : <Routes>
        <Route path="/dashboard" element={<Home history={navigate} />} />
        <Route path="/" element={<LoginContainer history={navigate} />} />
        <Route path="/privacy-policy" element={<Privacy history={navigate} />} />
        <Route path="/terms" element={<Terms history={navigate} />} />
        <Route path="/accountremoval" element={<AccountRemoval history={navigate} />} />
        <Route path="/orders" element={<OrderList history={navigate} />} />
        <Route path="/photographers" element={<PhotographerList history={navigate} />} />
        <Route path="/payments" element={<PaymentList history={navigate} />} />
        <Route path="/customers" element={<CustomerList history={navigate} />} />
        <Route path="/discounts" element={<DiscountList history={navigate} />} />
        <Route path="/feedback" element={<FeedbackPage history={navigate} />} />
        <Route path="/customer-ratings" element={<CustomerRatingsPage history={navigate} />} />
        <Route path="/pending-requests" element={<PendingRequestsPage history={navigate} />} />
        <Route path="/reviews" element={<ReviewsPage history={navigate} />} />
        <Route path="/admins" element={<AdminsPage history={navigate} />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/content" element={<ContentPage />} />
        <Route path="/notify" element={<PushNotifications />} />
        <Route path="/service-blocking" element={<AddUnavailableDates />} />
        <Route path="/live-map" element={<LiveTrackingMap />} />
        <Route path="/availability" element={<AvailabilityPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        {/* ACCOUNT REMOVAL PAGE TO BE MADE - Description and warning about data loss (gpt), Single input for Email / Phone Number, One Button Request Deletion,
        Confirmation should show that no data can be retrieved again and ask for yes or no */}
      </Routes>}
    </div>
  )
}

export const AppWithRouter = () => {
  const history = useNavigate();
  const location = useLocation();
  return <App navigate={history} location={location} />
}

export default App;
